<div class="content" fxLayout="column" fxLayoutGap="12px" [@routeAnimation]="true">
  <div fxLayout="column">
    <mat-form-field>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Search">
    </mat-form-field>
  </div>
  <div class="external-container mat-elevation-z8">
    <mat-table #table [dataSource]="dataSource" matSort>

      <!-- OrganizationName Column -->
      <ng-container matColumnDef="OrganizationName">
        <mat-header-cell style="flex-grow: 2.5" *matHeaderCellDef mat-sort-header="OrganizationName"
          class="cellSpacing headerCell"> Organization </mat-header-cell>
        <mat-cell style="flex-grow: 2.5" *matCellDef="let row" class="addEllipsis cellSpacing"
          title="{{row?.orgInfoExt?.name}}"> {{row?.orgInfoExt?.name}} </mat-cell>
      </ng-container>

      <!-- EIN Column -->
      <ng-container matColumnDef="EIN">
        <mat-header-cell style="flex-grow: 1" *matHeaderCellDef class="cellSpacing headerCell"> EIN
        </mat-header-cell>
        <mat-cell style="flex-grow: 1" *matCellDef="let row" class="addEllipsis cellSpacing"
          title="{{row?.orgInfoExt?.EIN}}"> {{row?.orgInfoExt?.EIN}} </mat-cell>
      </ng-container>

      <!-- EIN Column -->
      <ng-container matColumnDef="taxExemptStatus">
        <mat-header-cell style="flex-grow: 1.35" *matHeaderCellDef class="cellSpacing headerCell"> Tax
          Exempt Status </mat-header-cell>
        <mat-cell style="flex-grow: 1.35" *matCellDef="let row" class="addEllipsis cellSpacing"
          title="{{row?.orgInfoExt?.EIN}}"> {{getTaxExemptStatus(row?.orgInfoExt?.subsection_501)}} </mat-cell>
      </ng-container>

      <!-- FirstName Column -->
      <ng-container matColumnDef="FirstName">
        <mat-header-cell style="flex-grow: 1.25" *matHeaderCellDef mat-sort-header="FirstName"
          class="cellSpacing headerCell"> First Name </mat-header-cell>
        <mat-cell style="flex-grow: 1.25" *matCellDef="let row" class="addEllipsis cellSpacing"
          title="{{row?.externalUser?.firstName}}"> {{row?.externalUser?.firstName}} </mat-cell>
      </ng-container>

      <!-- LastName Column -->
      <ng-container matColumnDef="LastName">
        <mat-header-cell style="flex-grow: 1.25" *matHeaderCellDef mat-sort-header="LastName"
          class="cellSpacing headerCell"> Last Name </mat-header-cell>
        <mat-cell style="flex-grow: 1.25" *matCellDef="let row" class="addEllipsis cellSpacing"
          title="{{row?.externalUser?.lastName}}"> {{row?.externalUser?.lastName}} </mat-cell>
      </ng-container>

      <!-- Phone Column -->
      <ng-container matColumnDef="Phone">
        <mat-header-cell style="flex-grow: 1.5" *matHeaderCellDef class="cellSpacing headerCell"> Phone
        </mat-header-cell>
        <mat-cell style="flex-grow: 1.5" *matCellDef="let row" class="addEllipsis cellSpacing"
          title="{{row?.orgContactInfoExt?.phone}}"> {{row?.orgContactInfoExt?.phone}} </mat-cell>
      </ng-container>

      <!-- Email Column -->
      <ng-container matColumnDef="Email">
        <mat-header-cell style="flex-grow: 1.75" *matHeaderCellDef mat-sort-header="Email"
          class="cellSpacing headerCell"> Email </mat-header-cell>
        <mat-cell style="flex-grow: 1.75" *matCellDef="let row" class="addEllipsis cellSpacing"
          title="{{row?.externalUser?.email}}"> {{row?.externalUser?.email}} </mat-cell>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="Status">
        <mat-header-cell style="flex-grow: 1.35" *matHeaderCellDef class="addEllipsis cellSpacing headerCell">
          <div class="cellSpacing headerCell" mat-sort-header="Status" style="float:left; margin-top: 12px">
            Status</div>
          <div class="addEllipsis cellSpacing headerCell" style="float:left">
            <button mat-icon-button [matMenuTriggerFor]="filterMenu" title="Filter">
              <i class="fas fa-filter" style="color:#388e3c;"></i>
            </button>
          </div>
          <mat-menu #filterMenu="matMenu">
            <button mat-menu-item (click)="clearFilter()">Clear Filter</button>
            <button mat-menu-item (click)="approvedFilter()" *ngIf="tableType !== 'pending'">Approved Only</button>
            <button mat-menu-item (click)="rejectedFilter()" *ngIf="tableType !== 'pending'">Rejected Only</button>
            <button mat-menu-item (click)="pendingFilter()" *ngIf="tableType === 'pending'">Pending Approval
              Only</button>
            <button mat-menu-item (click)="pendingEINFilter()" *ngIf="tableType === 'pending'">Pending EIN Verification
              Only</button>
          </mat-menu>
        </mat-header-cell>
        <mat-cell style="flex-grow: 1.35" *matCellDef="let row" class="addEllipsis cellSpacing"
          title="{{row?.externalUser?.accessStatus?.includes('EIN')? 'PENDING EIN VERIFICATION': row?.externalUser?.accessStatus?.toUpperCase()}}">
          <span *ngIf="row?.externalUser?.accessStatus?.includes('pending')" style="font-weight: bold">
            {{row?.externalUser?.accessStatus?.includes('EIN')? 'PENDING EIN VERIFICATION': row?.externalUser?.accessStatus?.toUpperCase()}}
          </span>
          <span *ngIf="!(row?.externalUser?.accessStatus?.includes('pending'))">
            {{row?.externalUser?.accessStatus?.includes('EIN')? 'PENDING EIN VERIFICATION': row?.externalUser?.accessStatus?.toUpperCase()}}
          </span>
        </mat-cell>
      </ng-container>

      <!-- EIN Status Column -->
      <ng-container matColumnDef="EINStatus">
        <mat-header-cell style="flex-grow: 1.25" *matHeaderCellDef mat-sort-header="EINStatus"
          class="cellSpacing headerCell"> EIN verify status </mat-header-cell>
        <mat-cell style="flex-grow: 1.25" *matCellDef="let row" class="addEllipsis cellSpacing"
          [ngClass]="getEinStatus(row?.externalUser?.isVerified)"> {{getEinStatus(row?.externalUser?.isVerified)}}
        </mat-cell>

      </ng-container>

      <!-- Approve Column -->
      <ng-container matColumnDef="Approve">
        <mat-header-cell style="flex-grow: 0.15" *matHeaderCellDef class="action">
          <i class="fas fa-thumbs-up" title="Approve" style="color:#388e3c;"></i>
        </mat-header-cell>
        <mat-cell style="flex-grow: 0.15" *matCellDef="let row" class="action" (click)="$event.stopPropagation()">
          <i *ngIf="row?.externalUser?.accessStatus === 'approved' || row?.externalUser?.accessStatus === 'completed'"
            class="fas fa-thumbs-up" title="Approved" style="color:olivedrab;"></i>
          <i *ngIf="(row?.externalUser?.accessStatus?.includes('pending')) || (row?.externalUser?.accessStatus === 'rejected')"
            class="far fa-thumbs-up" title="Approve Access" style="color:olivedrab;" (click)="approveAccess(row)"></i>
        </mat-cell>
      </ng-container>

      <!-- Reject Column -->
      <ng-container matColumnDef="Reject">
        <mat-header-cell style="flex-grow: 0" *matHeaderCellDef class="action" (click)="$event.stopPropagation()">
          <i class="fas fa-thumbs-down" title="Reject" style="color:red;"></i>
        </mat-header-cell>
        <mat-cell style="flex-grow: 0" *matCellDef="let row" class="action">
          <i *ngIf="row?.externalUser?.accessStatus === 'rejected'" class="fas fa-thumbs-down" title="Rejected"
            style="color:red;"></i>
          <i *ngIf="row?.externalUser?.accessStatus?.includes('pending')" class="far fa-thumbs-down"
            title="Reject Access" style="color:red;" (click)="rejectAccess(row)"></i>
          <i *ngIf="row?.externalUser?.accessStatus === 'approved' || row?.externalUser?.accessStatus === 'completed'" class="far fa-thumbs-down" title="Approved"
            style="color:gray;"></i>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="showAccessRequestDetails(row)"></mat-row>
    </mat-table>

    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
  </div>
</div>